import SearchWatchListEntriesForm from './SearchWatchListEntriesForm';

export default SearchWatchListEntriesForm;


// WEBPACK FOOTER //
// ./src/features/watch-list-entry/components/search-watch-list-entries-form/index.js